import React, { AllHTMLAttributes, forwardRef } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { dropdown_label_base_css, dropdown_label_selected_style } from './styles';
import {
  getInputFontStyle,
  getInputSizeStyle,
  getInputSpacingBySize,
  getInputStatusIconSize,
  input_disabled_style,
  input_error_style,
  input_status_color_css,
} from '../input/styles';
import { DropdownArrowButton } from './DropdownArrowButton';
import { buildCSSWithLength, CSSValueWithLength } from '../../styles';
import { IconWarning } from '../icons/generated';
import { InputSize, InputStatus } from '../input/types';
import { Stack } from '../stack';

export interface DropdownLabelProps extends Omit<AllHTMLAttributes<HTMLDivElement>, 'size'> {
  height?: CSSValueWithLength;
  width?: CSSValueWithLength;
  flex?: React.CSSProperties['flex'];
  status?: Extract<InputStatus, 'error'>;
  disabled?: boolean;
  /**
   *  @default false
   *  Option listbox 오픈 여부
   */
  expanded?: boolean;
  /**
   * @default false
   * Option 선택 여부
   */
  selected?: boolean;
  size?: InputSize;
  actionCss?: SerializedStyles;
}

export const DropdownLabel = forwardRef<HTMLDivElement, DropdownLabelProps>(
  (
    {
      height,
      width,
      flex,
      disabled,
      expanded = false,
      selected = false,
      status,
      children,
      size = 'medium',
      actionCss,
      ...props
    },
    ref,
  ) => {
    const props_style = {
      ...(selected && dropdown_label_selected_style),
      ...(disabled && input_disabled_style),
    };
    const statusIconSize = getInputStatusIconSize(size);

    return (
      <div
        role='button'
        css={[
          dropdown_label_base_css,
          getInputSizeStyle(size),
          getInputFontStyle(size),
          props_style,
          css`
            ${width && buildCSSWithLength('width', width)}
            ${height && buildCSSWithLength('height', height)}
            ${flex !== undefined && `flex: ${flex};`}
            cursor: ${disabled ? 'not-allowed' : 'pointer'};
          `,
          status === 'error' && input_error_style,
        ]}
        ref={ref}
        {...props}
      >
        {children}
        <Stack direction='row' gap={getInputSpacingBySize(size)} align='center' css={actionCss}>
          {status === 'error' && <IconWarning size={statusIconSize} color={input_status_color_css.error} />}
          <DropdownArrowButton expanded={expanded} selected={selected} disabled={disabled} size={size} />
        </Stack>
      </div>
    );
  },
);
